import React, { memo, useState } from 'react'
import { Badge, Breadcrumb, BreadcrumbItem, Button, Card, Col, Row, Stack } from 'react-bootstrap'
import Moment from 'react-moment'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import ScrollIntersectionObserver from '../CustomControls/ScrollIntersectionObserver'

 const  PresetTourCard = (props) => {
    const location = useLocation();
    const isHome = location.pathname == '/';

    const [showResults, setShowResults] = useState(false)
    const handleMoreInfoBtnClick = (e) => {
        setShowResults(!showResults)
    }
  
    return (
          <Card style={{ maxWidth: "600px"}} id='trCard' className={isHome ? 'bk-mint border-0 rounded-3 overflow-hidden lead text-dark tr-card home'
          :'bk-mint border-0 rounded-3 overflow-hidden tr-card lead text-dark'}>
            <Card.Body className='full-size'>
                {/* <Col className='col-xs-12 col-md-12 col-lg-12 align-items-center'>
                    <div className='ms-auto'>
                        <Badge bg='success' className='bk-green'>{props.tour.status && props.tour.status.display_name}</Badge>
                    </div>
                </Col> */}
                <div className='tr-header'>
                    <h4 className='tr-heading lead'>{props.tour && props.tour.display_name}</h4>

                    <p className='tr-sub'>
                        <Moment format='DD MMMM, YYYY HH:mm A' unix date={props.tour.departure_time && props.tour.departure_time.seconds} />
                    </p>
                    {/* <p className='text-center'>Bus Arrival is {' '}
                        <i className='font-weight-bold text-decoration-underline'><Moment format='dddd \t\h\e Do \o\f MMMM, YYYY \a\t HH:mm A' unix date={props.tour.arrival_time && props.tour.arrival_time.seconds} /></i> |
                        Bus Departure is at <i className='font-weight-bold text-decoration-underline'><Moment format='HH:mm A' unix date={props.tour.departure_time && props.tour.departure_time.seconds} /></i>
                    </p> */}
                </div>
                <Stack direction='horizontal' className='tr-info-items'>
                    <div className='tr-info-item text-center w-100'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="tr-info-icon bi bi-person-badge" viewBox="0 0 16 16">
                            <path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                            <path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0h-7zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492V2.5z"/>
                        </svg>
                        <p className='tr-info-text'>{props.tour && props.tour.driver && props.tour.driver.display_name}</p>
                    </div>
                    <div className='tr-info-item text-center w-100'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="tr-info-icon bi bi-bus-front-fill" viewBox="0 0 16 16">
                            <path d="M16 7a1 1 0 0 1-1 1v3.5c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.496 2.496 0 0 1-1-2V8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1V2.64C1 1.452 1.845.408 3.064.268A43.608 43.608 0 0 1 8 0c2.1 0 3.792.136 4.936.268C14.155.408 15 1.452 15 2.64V4a1 1 0 0 1 1 1v2ZM3.552 3.22A43.306 43.306 0 0 1 8 3c1.837 0 3.353.107 4.448.22a.5.5 0 0 0 .104-.994A44.304 44.304 0 0 0 8 2c-1.876 0-3.426.109-4.552.226a.5.5 0 1 0 .104.994ZM8 4c-1.876 0-3.426.109-4.552.226A.5.5 0 0 0 3 4.723v3.554a.5.5 0 0 0 .448.497C4.574 8.891 6.124 9 8 9c1.876 0 3.426-.109 4.552-.226A.5.5 0 0 0 13 8.277V4.723a.5.5 0 0 0-.448-.497A44.304 44.304 0 0 0 8 4Zm-3 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm8 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-7 0a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1Z"/>
                        </svg>
                        <p className='tr-info-text'>{props.tour && props.tour.bus && props.tour.bus.display_name}</p>
                    </div>
                    <div className='tr-info-item text-center w-100'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="tr-info-icon bi bi-person-circle" viewBox="0 0 16 16">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                            <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
                        </svg>
                        <p className='tr-info-text'>{props.tour && props.tour.guide && props.tour.guide.display_name}</p>
                    </div>
                </Stack>
                { isHome ? <ScrollIntersectionObserver element='tr-card' isClass={true} /> : null }
                <div className='tr-map'>
                    <Row className='w-100 m-0'>
                        <Col className='tr-vm-info d-flex justify-content-center'>
                        <span onClick={(e) => handleMoreInfoBtnClick()}>
                            <svg id='trViewMore' xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="tr-vm-icon bi bi-arrow-down-circle-fill" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"/>
                            </svg>
                        </span>
                        </Col>
                    </Row>
                    
                    <div className={showResults ? 'tr-map-info active' : 'tr-map-info'}>
                        <div className='tr-map-item'>
                            <img className='tr-map-icon' title={'Drop Off Location'} alt={'Drop Off Location Icon'} src={process.env.PUBLIC_URL + '/icons/icons8-bus-stop-96.png'} loading="lazy" decoding="async" width={48} height={48}></img> 
                            <span className='tr-map-txt'>{props.tour && props.tour.drop_off_location && props.tour.drop_off_location.display_name}</span>
                        </div>
                        <div className='tr-map-item'>
                            <div className='tr-map-item' data-carets={'carets'}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="tr-map-caret bi bi-caret-right-fill" viewBox="0 0 16 16">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="tr-map-caret bi bi-caret-right-fill" viewBox="0 0 16 16">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="tr-map-caret bi bi-caret-right-fill" viewBox="0 0 16 16">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="tr-map-caret bi bi-caret-right-fill" viewBox="0 0 16 16">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                </svg>
                            </div>    
                        </div>
                        <div className='tr-map-item'>
                            <img className='tr-map-icon' title={'Pick Up Location'} alt={'Pick Up Location Icon'} src={process.env.PUBLIC_URL + '/icons/icons8-map-marker-96.png'} loading="lazy" decoding="async" width={48} height={48}></img>
                            <span className='tr-map-txt'>{props.tour && props.tour.pickup_location && props.tour.pickup_location.display_name}</span>
                        </div>
                    </div>

                    <Stack className={showResults ? 'tr-journey active' : 'tr-journey'} direction='vertical' gap={3}>
                        <Breadcrumb className='ms-auto'>
                            {props.tour && props.tour.locations && props.tour.locations.map((location, index) => {
                                return(
                                <div key={props.tour && props.tour.id + '-' + location.id + 'icon'}>
                                { index > 0 ?
                                    <div className='tr-bread-icon'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="tr-map-caret bi bi-caret-right-fill" viewBox="0 0 16 16">
                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                    </svg></div> : null
                                }
                                    <BreadcrumbItem className='rg-label dark mb-1' href={'/location/'+ location.display_name +'/' + location.id }>{location.display_name}</BreadcrumbItem>
                                </div>
                                )
                            })}
                        </Breadcrumb>
                    </Stack>
                </div>


                {/* <Row>
                    <Col>
                        <img style={{ width: '60%' }} title={'Adult Cost'} alt={'Adult Icon'} src={process.env.PUBLIC_URL + '/icons/icons8-lady-skin-type-1-color/icons8-lady-skin-type-1-48.png'}></img> {props.tour.adult_cost}
                    </Col>

                        <Col>
                            <img style={{ width: '60%' }} title={'Child Cost'} alt={'Child Icon'} src={process.env.PUBLIC_URL + '/icons/icons8-babys-room-48.png'}></img> {props.tour.child_cost}
                        </Col>
                        <Col className='d-flex justify-content-center align-items-center'>
                            <div>
                                <Badge bg='light' className='text-dark'>{props.tour.currency && props.tour.currency.display_name}</Badge>
                            </div>
                        </Col>
                    </Row> */}
                
                     <div className='mb-2 d-flex justify-content-center text-center'>
                    {/*    <motion.div
                            whileTap={{ scale: 0.9 }}>
                            <Button variant='success'>Add to Calendar</Button>
                        </motion.div>  */}
                            <Link
                                role='button'
                                className='tr-btn btn bt-dark txt-mint'
                                to={'/tours/reserve/' + (props.tour && props.tour.id)}>Reserve
                            </Link>
                    </div>
            </Card.Body>
        </Card>
  )
}

export default memo(PresetTourCard);
